
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`នេះត្រូវបាននាំមកដោយ
                    <a href="${0}">គម្រោងម៉ាស៊ីន Folksonomy</a>។ កុំ
                    ស្ទាក់ស្ទើរក្នុងការចូលរួម ឬផ្តល់មតិកែលម្អ`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`ឧបករណ៍នេះអនុញ្ញាតឱ្យអ្នកកែបញ្ជីគ្រឿងផ្សំ។ អ្នកអាចបន្ថែម លុប ឬកែសម្រួលបញ្ជីគ្រឿងផ្សំ
                ។
                <br>
                តួអក្សរនេះ <span class="highlight">␣</span> តំណាងឱ្យចន្លោះមួយ។
                <br>
                តួអក្សរនេះ <span class="highlight">↩︎</span> តំណាងឱ្យការបំបែកបន្ទាត់។ `,
'hb28f1f2ec1744ee9': html`លក្ខណៈសម្បត្តិទាំងនេះត្រូវបានបង្កើត និងដាក់ឯកសារដោយអ្នកប្រើប្រាស់សម្រាប់ប្រភេទនៃការប្រើប្រាស់ណាមួយ។ មានអារម្មណ៍ថា
                    ដោយឥតគិតថ្លៃដើម្បីបន្ថែមផ្ទាល់ខ្លួនរបស់អ្នក។ លក្ខណៈសម្បត្តិ និងតម្លៃដែលអ្នកបង្កើត
                    <strong>ត្រូវតែជាការពិត</strong>។ អ្នកអាចចូលទៅក្នុង
                    <a href="${0}">បញ្ជីអចលនទ្រព្យដែលបានប្រើរួចហើយដោយសហគមន៍</a>
                    ឬរុករកឯកសារ
                    <a href="${1}">និងម៉ាស៊ីនស្វែងរករបស់វា</a>។`,
's000a5b76bd3a01c2': `កំពុងផ្ទុកលក្ខណៈសម្បត្តិ...`,
's000d98595e959c1e': `Get It On Google Play`,
's013bdc8cf0d3583d': `ជួយយើងសម្រាប់គ្រឿងផ្សំ`,
's01d2865e3e1d5501': `Thank you for your assistance!`,
's02ce7a2e7c1b020b': `ធ្វើឱ្យដំណាំមានសុពលភាព`,
's03e9c8114521b998': `ខ្ញុំនឹងកែសម្រួលគ្រឿងផ្សំ`,
's05ec315d9308091a': `រូបតំណាងជ្រុងបារកូដ`,
's061eb5af92512c85': `រក្សាទុក! តើអ្នកអាចជួយមួយផ្សេងទៀតបានទេ?`,
's06847c221c4c0bc1': `ខ្ញុំចង់បង្កើតទ្រព្យមួយដើម្បី [ពិពណ៌នាករណីប្រើប្រាស់របស់អ្នក]...`,
's06f6c6f99db6b552': `ដើម`,
's081e2ad82db71e1d': `តម្លៃជាក្រុម`,
's09205907b5b56cda': `No`,
's0b4235aae602a950': `ឯកសារជាក់លាក់`,
's0bb2d48532acc455': `ទាញយក CSV`,
's0d5b7fee0311db68': `Property`,
's0fb218abc2e157ed': `ធ្វើឱ្យរូបភាពមិនត្រឹមត្រូវ`,
's100c4928cc74642a': `support the advancement of public health research.`,
's10db5498186c083b': `បោះបង់ដំណាំ`,
's11a18a69b30b65ed': `ជួយយើងជួសជុលកំហុសក្នុងបញ្ជីគ្រឿងផ្សំ`,
's1205d5f6fccf8e69': `តម្លៃអចលនទ្រព្យ`,
's15d64a0a6715285a': `សោថ្មី។`,
's166bd56d19670a72': `Zoom`,
's19059bf0c4f7c162': `តំបន់ជ្រើសរើស`,
's1a52515ec8ddade8': `Product barcode`,
's1c5031113de500ce': `keeping our database open &amp; available to all,`,
's1dc4daf989c71284': `ជួយយើងកែតម្រូវព័ត៌មានអាហារូបត្ថម្ភ`,
's1e00019dc454872d': `សូម​ផ្តល់​ឈ្មោះ​អចលនទ្រព្យ​ដោយ​ប្រើ​គុណលក្ខណៈ​ឈ្មោះ​អចលនទ្រព្យ។`,
's1e49126af0935a5b': `បញ្ជីផលិតផលដែលប្រើប្រាស់ទ្រព្យសម្បត្តិនេះ។`,
's21e73088de6f26f3': `Download on the App Store`,
's255857544a9d5ec0': `Reset`,
's25e94495991e95ba': `Thanks for your help! Can you assist with another question?`,
's2ceb11be2290bb1b': `Cancel`,
's2db7b654c0a9bde0': `ចងក្រងឯកសារទ្រព្យសម្បត្តិ`,
's300b3a6ee4e1252d': str`ការប្រកួតមិនល្អ ${0}%`,
's33f786bb6b4f0cf4': `លទ្ធផលដំណាំ`,
's33f85f24c0f5f008': `Save`,
's34be4af4e8fec4ae': `សួរសហគមន៍ជាមុនសិន`,
's36d86adc823cbfa6': `មុននឹងបង្កើតអចលនទ្រព្យថ្មី សូមពិភាក្សាជាមួយសហគមន៍៖`,
's3781d25aa51a736c': `ឯកសារម៉ាស៊ីន Folksonomy`,
's383ae4449428b61e': `កំណត់ការច្រឹបឡើងវិញ`,
's39bcf88721a1e8ee': `កំណត់ជម្រើសឡើងវិញ`,
's39e14e14300694c7': `ឯកសារ និងសេចក្តីណែនាំ`,
's3b430cfa5c1fe7f4': str`ឯកសារសម្រាប់ ${0}`,
's3f4e4b52f230a892': `ផ្ទាំងក្រណាត់`,
's417b90913e05bc17': `Preview`,
's41f7dca46d3f1b4a': `Value`,
's422bba9636ce2489': `រូបភាពកណ្តាល`,
's42dd66b2441566fd': `រូបតំណាងកណ្តាល`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `Add a nutrient`,
's453ab0dbb9b5c777': `ប្តូរទំហំត្រឹមត្រូវ។`,
's475b08749d0706ed': `Help us inform millions of consumers around the world about what they eat`,
's49730f3d5751a433': `Loading...`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4d42cc7e00076a3b': `ចំនួនផលិតផល`,
's4df2f533c0c1e7d0': `ការគ្រប់គ្រងរូបភាព`,
's4e94adf723979402': `Open Food Facts needs your help with this product.`,
's4f4886341969d552': `ផ្លាស់ទី​ជម្រើស`,
's4f751fb9b3ed766c': `ការបង្កើតអចលនទ្រព្យថ្មី។`,
's547c12ae169d00bc': `Available on F-Droid`,
's5560fb119e40923d': `បញ្ចូលឈ្មោះអចលនទ្រព្យ...`,
's55d7249883a98ca1': `អំពីទ្រព្យសម្បត្តិនេះនៅលើ Open Food Facts wiki`,
's565867d84c04aea2': `លក្ខណៈសម្បត្តិតម្រង...`,
's5666afe5cd0166de': `សូមជួសជុលកំហុស ឬកែប្រែអត្ថបទមុនពេលបញ្ជាក់`,
's57472465a23b41db': `Values`,
's58e1eeea7a60ae51': `កំពុងផ្ទុកផលិតផល...`,
's59df20feee978e5b': `Error: Invalid value.`,
's5c92c0051d44b6de': `ជួយយើងកែតម្រូវព័ត៌មានអាហារូបត្ថម្ភ។`,
's5dd6f12783fca34f': `កែសម្រួលបញ្ជីគ្រឿងផ្សំ`,
's5e8250fb85d64c23': `Close`,
's5ed03bb1f3a15949': `Picture`,
's6306a31415aea913': `I SUPPORT`,
's6498dfe4855bb3a7': `unit`,
's64ef2a6c2dd1d3d1': `កែសម្រួល`,
's66413c24dcf680e2': `Skip`,
's67ae6594857a4d57': `Thanks for your contribution!`,
's6cee7cad81dfedd1': `រូបភាពដែលបានច្រឹប`,
's6d7b6cdedaadfb6e': `Each donation counts! We appreciate your support in bringing further food transparency in the world.`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`ការប្រកួតល្អ ${0}%`,
's71a5c9f4b68ef4d4': `Count`,
's74cb3d66f6a668e1': `ឯកសារ`,
's787dd11bed0dc88a': `ប្តូរទំហំខាងឆ្វេង`,
's7ce4fd9430e80cea': `value`,
's801a05fa8e881f37': `ស្វែងយល់បន្ថែមអំពីការបង្កើត និងគោលការណ៍ណែនាំអំពីអចលនទ្រព្យ៖`,
's8038273de2cf8b73': `សូមជ្រើសរើសតំបន់ដែលត្រូវច្រឹប។`,
's839cc2908a5387f2': `ត្រងបាកូដ...`,
's86197dcf3e96af64': `រកមើល និងស្វែងរកលក្ខណៈសម្បត្តិដែលមានស្រាប់`,
's8a63be30a129a59c': `ប្តូរទំហំបាត`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `ប្តូរទំហំខាងស្តាំខាងលើ`,
's8db84aa4bc949af2': `ចងក្រងឯកសារអចលនទ្រព្យថ្មី។`,
's8f839a03997a16d7': `មើលផលិតផល`,
's901ae1e236ac45d3': `បោះបង់ការលុប`,
's907f7a97c6b29425': `សូមដឹងថាគំរូទិន្នន័យអាចត្រូវបានកែប្រែ។ ប្រើដោយហានិភ័យផ្ទាល់ខ្លួនរបស់អ្នក។`,
's95d23d03f9147581': `Unzoom`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `គ្រឿងផ្សំ៖`,
's9a7f60fce090ecaf': `បានបរាជ័យក្នុងការផ្ទុកលក្ខណៈសម្បត្តិ។ សូមព្យាយាមម្តងទៀតនៅពេលក្រោយ។`,
's9b87abd68fb9df45': `រកមិនឃើញ? បង្កើតសោថ្មី {value}`,
's9c0f52425fd2f07e': `ប្រហែលជាមិនផ្គូផ្គង`,
's9fc41f789c63b40d': `Products`,
'sa1fa766e0d5634d7': `មិនមានពិន្ទុទេ។`,
'sa548778b24054030': `រុករកអចលនទ្រព្យដែលបានចូលរួមចំណែកទាំងអស់ពីគម្រោង Folksonomy Engine ។ លក្ខណៈសម្បត្តិទាំងនេះផ្តល់នូវទិន្នន័យមេតា និងការយល់ដឹងបន្ថែមអំពីផលិតផលនៅក្នុងមូលដ្ឋានទិន្នន័យ Open Food Facts ។`,
'sa63907958bd0ec4b': `ប្តូរទំហំផ្នែកខាងលើខាងឆ្វេង`,
'sa95b4224f685a36a': `ម៉ូឌុលបិទ`,
'sab56a1d439576fd6': `រូបតំណាងណែនាំ`,
'sac47ea2901d04c15': `ប្តូរទំហំបាតខាងឆ្វេង`,
'sb125227d436c2925': `ស្វែងរកគំនិតអចលនទ្រព្យរបស់អ្នកនៅក្នុងមូលដ្ឋានទិន្នន័យអចលនទ្រព្យដែលមានស្រាប់៖`,
'sb125568d43642e6f': `ឆ្លើយសំណួរអំពីផលិតផល។`,
'sb1c538e038f9b214': str`ការប្រកួតល្អណាស់ ${0}%`,
'sb28639570ff3b852': `បញ្ជីនៃទ្រព្យសម្បត្តិទាំងអស់។`,
'sb3bdd638a58d30f4': `engage a community of committed citizens,`,
'sb3cbcc1bd0fff140': `នៅពេលដែលអ្នកបានផ្ទៀងផ្ទាត់ថាទ្រព្យសម្បត្តិរបស់អ្នកមិនមាន ហើយសហគមន៍យល់ស្របថាវាមានប្រយោជន៍ អ្នកត្រូវចងក្រងឯកសារវានៅក្នុងវីគីជាមុនសិន។`,
'sb3d4f79d9d8b71e5': `Submit`,
'sb560fa37a7bfb6c2': `រកមិនឃើញផលិតផលសម្រាប់ទ្រព្យសម្បត្តិនេះទេ។`,
'sb7f72e4c8a2d3357': `តម្លៃ​តម្រង...`,
'sb8178320160f84ea': `បង្ហាញដំណាំ`,
'sbad7d2734149470b': `Validate`,
'sbb623d6b18d966a0': `Nutrition facts are displayed on the packaging:`,
'sbd6be5cde472f37c': `ការយល់ដឹងទាំងអស់ត្រូវបានឆ្លើយ! អរគុណសម្រាប់ជំនួយរបស់អ្នក!`,
'sbd9a0b2293b3cd3c': `Serving size`,
'sbe472dc3c2685985': `តម្លៃដែលត្រូវគ្នា។`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `ប្តូរទំហំផ្នែកខាងលើ`,
'sc1c08d0cbcc3bd24': `មិនត្រូវគ្នា។`,
'sc52696641af72b53': `Install the app!`,
'sc5575e3107f87874': `Rotate image to the left`,
'sc57b630a7a70c61f': `ការជួសជុលដែលបានណែនាំ`,
'sc681b137e8f604f7': `បញ្ជាក់ការលុប`,
'sc6daf8a31883f8b9': `ផ្លាស់ទីរូបភាព`,
'sc895972c88d38ca5': `ទ្រព្យសម្បត្តិ Folksonomy`,
'sca0c3305aff570b8': str`per specified serving "${0}"`,
'scace072bef961918': `ជួរដេក`,
'scb3b0671d7b7f640': `តម្លៃថ្មី។`,
'scb489a1a173ac3f0': `Yes`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `ចូលរួមការពិភាក្សា Slack`,
'scdb6cad0b92721bf': `រកមិនឃើញទ្រព្យសម្បត្តិទេ។`,
'scf23a05631f93732': `បញ្ជាក់ការលុប`,
'scfed2f270ef6a3aa': `ជ្រើសរើសតំបន់`,
'sd1022bc1ef9204f7': `រូបភាពដែលអាចពង្រីកបាន។`,
'sd1077c055cf9ba6b': `ជួយយើងក្នុងការផ្ទៀងផ្ទាត់បញ្ជីធាតុផ្សំនៃផលិតផល។`,
'sd698d21ddecba56b': `ហេ! អ្នក​អាច​ជួយ​យើង​កែលម្អ​ព័ត៌មាន​ផលិតផល​ដោយ​ឆ្លើយ​តប​ផ្នែក​ខាងក្រោម​នេះ៖`,
'sd82bc2decefa621b': `remain independent of the food industry,`,
'sdb97e5976482606e': `ពិនិត្យមើលថាតើទ្រព្យសម្បត្តិមានរួចហើយឬអត់`,
'sdbf806fefc584115': `អ្នកគួរតែស្វែងរក ក`,
'sdc673e73b5c13aea': `លុប`,
'sdc792b75f1edcaba': `ជួយយើងកែអក្ខរាវិរុទ្ធនៃគ្រឿងផ្សំ។`,
'sdca5deead576ceee': `ប្ដូរ​ទំហំ​បាត​ស្ដាំ`,
'sdcc2555c5dde524f': `តើអ្នកប្រាកដថាចង់លុបធាតុនេះទេ? សកម្មភាពនេះមិនអាចត្រឡប់វិញបានទេ។`,
'se206feec7ec57b28': `per 100g`,
'se419a9ab36987490': `មិនត្រឹមត្រូវ`,
'se5127cf0f92e7e48': `គន្លឹះ៖ អ្នកក៏អាចរកឃើញ`,
'se773f50d2a16d481': `Rotate image to the right`,
'sebb2c6c830a44574': `technical infrastructure (website/mobile app) &amp; a small permanent team`,
'sec6377f3c4e9b28c': `ខ្ញុំនឹងស្នើឱ្យដាំដំណាំល្អជាង`,
'seea3800e27baa686': `ផលិតផលបុគ្គល`,
'sefaba4adc4ec9219': `លក្ខណៈសម្បត្តិ Folksonomy`,
'seffa8ca49175b5f0': `លក្ខណៈសម្បត្តិផ្ទាល់ខ្លួន`,
'sf44a6b3b232c28ea': str`ជំនួសតម្លៃបច្ចុប្បន្នដោយ ${0}`,
'sf4cd86a2f5ef2588': `លេខកូដផលិតផល`,
'sf57a61152168cc81': `ជួយយើងកែតម្រូវការរកឃើញធាតុផ្សំ`,
'sf88b90b8ba23871c': `ការប្រកួតមិនស្គាល់`,
'sf9aee319a006c9b4': `Add`,
'sfacbbe968fa7d773': `ឈ្មោះអចលនទ្រព្យ៖`,
'sfc40ea3d5d5aa6f8': `Your donations fund the day-to-day operations of our non-profit association:`,
'sfe87465d50530725': `តម្លៃដែលត្រូវគ្នា។`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  